import React, { } from "react";
import "./filter-section.scss";
import "./sort-dropdown";
import SortDropdown from "./sort-dropdown";
import HeaderSearchIcon from "../../../images/home/header-search-icon.svg";
import { CrossIcon } from "../../../components/svgicons";

const FilterSection = ({ selectedSubcategory, catalogueCount, handleSortChange, handleSearchInput, searchText, onResetSearch }) => {
  return (
    <>
      <div className="filter-section-kl">
        <div className="filter-section-inner-kl">
          <div className="filter-section-left-kl">
            <div className="filter-section-all-count-kl">
              {selectedSubcategory}
              <span >({catalogueCount})</span>
            </div>
          </div>
          <div className="filter-section-right-kl">
            <div className="filter-section-sort-kl">
              <div className="filter-section-search-kl">
                <img className="filter-search-icon-kl" src={HeaderSearchIcon} alt="" />
                <input value={searchText} className="form-control" type="text" placeholder="Search Products" onChange={(e) => {
                  handleSearchInput(e)
                }} />
                {searchText && <button onClick={onResetSearch} className="filter-search-reset-icon-kl-btn">
                  <CrossIcon />
                </button>}
              </div>
              <SortDropdown handleSortChange={handleSortChange} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSection;
